import * as actions from '../actions';
import { getState } from '../core/store';
import { getLoginUrl, getTemplate } from '../helpers';

const renderModal = () => {
  const { modalVisible } = getState();
  let modal = document.querySelector('.selectives-bookmarking-modal');

  // append div only when we need to show it
  if (!modal && modalVisible) {
    modal = document.createElement('div');
    modal.className = 'selectives-bookmarking-modal hidden';
    modal.addEventListener('click', handleClick);
    document.body.appendChild(modal);

    document.addEventListener('keyup', handleKeyUp);
    // page load events
    modal.innerHTML = getModalTemplate();
  }

  // if there is already a modal element, update the modal based on the state. Als disable scroll.
  modal?.classList.toggle('hidden', !modalVisible);
  document.body.classList.toggle('body-disable-scrolling', modalVisible);
};

const handleKeyUp = (e: KeyboardEvent) => {
  if (e.code === 'Escape') {
    actions.closeModal();
  }
};

const handleClick = (e: Event) => {
  if (!(e.target instanceof HTMLElement)) return;

  if (e.target.closest('[data-action-close]')) {
    return actions.closeModal();
  }
  if (e.target.closest('[data-action-login]')) {
    const { brandName } = getState();
    return (location.href = getLoginUrl(brandName));
  }
};

const getModalTemplate = () => {
  return `
  <div class="bg" data-action-close></div>
  <div class="modal-content-container" role="dialog" aria-modal="true">
    <div class="bookmarking-content">
      ${getModalContent()}
      ${closeButton}
    </div>
  </div>`;
};

const closeButton = `<button class="button-close" aria-label="sluiten" data-action-close>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
<title>Sluiten</title>
  <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 4 4 20M4 4l16 16"/>
</svg>
</button>`;

const getModalContent = () => {
  const { sessionLoggedIn, brandName } = getState();
  return getTemplate(
    brandName,
    'article',
    'onboardingPopup',
    sessionLoggedIn ? 'loggedIn' : 'loggedOut'
  );
};

export { renderModal };
